document.addEventListener('DOMContentLoaded', function() {
    const productThumbSlider = new Swiper(".review-slider .swiper-slider", {
        slidesPerView: 1.05,
        spaceBetween: 16, 
        breakpoints: {                
            768: {
              slidesPerView: 2, 
              spaceBetween: 20,                  
            },
            1024: {
                slidesPerView: 3, 
                spaceBetween: 20,                  
            }          
        },
        navigation: {
            nextEl: ".review-slider .swiper-button-next",
            prevEl: ".review-slider .swiper-button-prev",
        } 
    });
    const logoSlider = new Swiper(".rich-text-v2 .swiper-slider", {
        slidesPerView: "auto",
        freeMode: true,
        spaceBetween: 24,
    })
    const collectionfilter = new Swiper('.collections-filter-slider', {
        slidesPerView: "auto",
        freeMode: true,
        spaceBetween: 16,
    })
    const colEles = document.querySelectorAll('.featured-collections .swiper-slider');
    colEles.forEach((colEle, index) => {
        const colSlider = new Swiper(colEle, {
            slidesperView: 1.2,
            spaceBetween: 16,
            cssMode: true,
            breakpoints: {           
                200: {
                    slidesPerView: 1.2,
                    spaceBetween: 16,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                990: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
                1199: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                }
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            } 
        })
    })
    
    
});

